import { css } from 'linaria';

export const modalStyle = css`
  height: 324px;
`;

export const textStyle = css`
  display: block;
  width: max-content;
`;

export const buttonWrapper = css`
  display: flex;
  justify-content: center;
`;

export const modalHeader = css`
  && {
    width: 75%;
    margin-top: 40px;
    margin-left: 40px;
    font-weight: 600;

    @media (width <= 375px) {
      width: 232px;
      margin-top: 16px;
      margin-left: 16px;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const modalFooter = css`
  && {
    margin-top: 0;
  }
`;
